import React, { useEffect, useRef, useState } from 'react';
import { classNames } from 'src/utils/classNames';
import styles from './index.module.scss';

interface Props {
  children?: any;
  className?: string;
  fontSize: number;
  inline?: boolean;
}
const SmallText: React.FC<Props> = ({
  children,
  className,
  fontSize,
  inline
}) => {
  const ref = useRef<HTMLElement>(null);
  const [height, setHeight] = useState(fontSize);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    setTimeout(() => {
      if (!ref.current) return;
      setHeight(ref.current.clientHeight / 2);
      if (inline) {
        setWidth(ref.current.clientWidth / 2);
      }
    });
  }, [children, inline]);
  return (
    <div
      className={classNames([
        styles.container,
        className,
        inline ? styles.inline : styles.paragraph
      ])}
      style={{ minHeight: height, minWidth: width }}
    >
      <span ref={ref} style={{ fontSize: `${(fontSize * 2) / 75}rem` }}>
        {React.Children.map(children, child => child)}
      </span>
    </div>
  );
};

export default SmallText;
